var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-navbar",
    { attrs: { toggleable: "md", type: "dark", variant: "dark" } },
    [
      _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
      _vm._v(" "),
      _c("b-navbar-brand", { attrs: { to: { name: "index" } } }, [
        _c("i", { staticClass: "fa fa-comment-medical" }),
        _vm._v(" NHT "),
        _c("span", { staticClass: "small text-primary" }, [_vm._v("CLINIC")]),
      ]),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { "is-nav": "", id: "nav_collapse" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c("b-nav-item", { attrs: { to: { name: "index" } } }, [
                _vm._v("Home"),
              ]),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { to: { name: "about" } } }, [
                _vm._v("About the App"),
              ]),
              _vm._v(" "),
              _vm.$route.name == "test.begin"
                ? _c("b-nav-item", { attrs: { to: { name: "index" } } }, [
                    _vm._v("Abort Test"),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }